"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeKeepShape = void 0;
const lodash_1 = __importDefault(require("lodash"));
function _mergeKeepShapeArray(dest, source) {
    if (source.length !== dest.length) {
        return dest;
    }
    const ret = [];
    dest.forEach((v, i) => {
        ret[i] = _mergeKeepShape(v, source[i]);
    });
    return ret;
}
function _mergeKeepShapeObject(dest, source) {
    const ret = {};
    Object.keys(dest).forEach((key) => {
        const sourceValue = source[key];
        if (typeof sourceValue !== "undefined") {
            ret[key] = _mergeKeepShape(dest[key], sourceValue);
        }
        else {
            ret[key] = dest[key];
        }
    });
    return ret;
}
function _mergeKeepShape(dest, source) {
    if (lodash_1.default.isArray(dest)) {
        if (!lodash_1.default.isArray(source)) {
            return dest;
        }
        return _mergeKeepShapeArray(dest, source);
    }
    else if (lodash_1.default.isObject(dest)) {
        if (!lodash_1.default.isObject(source)) {
            return dest;
        }
        return _mergeKeepShapeObject(dest, source);
    }
    else {
        return source;
    }
}
exports.mergeKeepShape = (existingValue, extendingValue) => {
    return _mergeKeepShape(existingValue, extendingValue);
};
//# sourceMappingURL=mergeKeepShape.js.map